export default "__VITE_ASSET__wCWZYu2w__"